import urlUtil from 'url';
import { isObject } from '@config/utils';
import { getLayerUrl } from '../LayersUtils';
import { getAuthorizationBasic } from '../SecurityUtils';
import { interceptOGCError } from '../ObservableUtils';

export default {
    /**
     * Creates the request object and it's metadata for WMS GetFeatureInfo.
     * @param {object} layer
     * @param {object} options
     * @param {string} infoFormat
     * @param {string} viewer
     * @return {object} an object with `request`, containing request paarams, `metadata` with some info about the layer and the request, and `url` to send the request to.
     */
    buildRequest: (layer, { coordinate, resolution, projection, currentLocale, params: defaultParams, maxItems = 10, tolerance = 0 } = {},
        infoFormat, viewer, featureInfo) => {
        let source = layer.getSource();
        let urlRequest = source.getFeatureInfoUrl(
            coordinate,
            resolution,
            projection,
            {
                FEATURE_COUNT: maxItems,
                INFO_FORMAT: infoFormat,
                STYLES: featureInfo?.styles ?? '',
                EXCEPTIONS: source.v13_ ? 'XML' : 'application/vnd.ogc.se_xml',
                // geoserver
                BUFFER: tolerance,
                // qgis-server
                FI_POINT_TOLERANCE: tolerance,
                FI_LINE_TOLERANCE: tolerance,
                FI_POLYGON_TOLERANCE: tolerance,
            }
        );
        let request = {
            id: layer.get('id') || layer.id,
        };
        if(urlRequest){
            const parsed = urlUtil.parse(urlRequest, true);
            Object.assign(request, parsed.query);
        }
        let title = layer.title || layer.get('title') || layer.name || layer.get('name');
        return {
            request,
            metadata: {
                title: isObject(title) ? title.default : title,
                regex: layer.featureInfoRegex,
                viewer,
                // fields: layer.fields,
                featureInfo
            },
            url: getLayerUrl(layer).replace(/[?].*$/g, '')
        };
    },
    /**
     * Returns an Observable that emits the response when ready.
     * @param {object} layer the layer
     * @param {string} baseURL the URL for the request
     * @param {object} params for the request
     */
    getIdentifyFlow__: (layer, basePath, params) => {
        const headers = getAuthorizationBasic(layer?.security?.sourceId);
        return Observable.defer(() => axios.get(basePath, { params, headers }))
            .let(interceptOGCError);
    }
};